// These paths are relative to the host router's /ai-open-platform/ base.
export const memcoreRoutes = [
  {
    path: '',
    name: 'memcoreHome',
    component: () => import('./views/HomePage.vue'),
  },
  {
    path: 'chat/:id',
    name: 'memcoreChat',
    component: () => import('./views/ChatPage.vue'),
  },
  {
    path: 'memories',
    name: 'memcoreMemories',
    component: () => import('./views/MemoriesPage.vue'),
  },
  {
    path: 'memory-graph',
    name: 'memcoreMemoryGraph',
    component: () => import('./views/MemoryGraphPage.vue'),
  },
  {
    path: 'login',
    name: 'memcoreLogin',
    component: () => import('./views/LoginPage.vue'),
    meta: { public: true },
  },
  {
    path: 'sso-callback',
    name: 'memcoreSSOCallback',
    component: () => import('./views/SSOCallbackView.vue'),
    meta: { public: true },
  },
]